import client from '../client'

export async function changeDealershipDetailsRequest({
  userId,
  firstName,
  lastName,
  phoneNumber,
  zipCode,
  dealerUserType,
  dealershipName,
  dealershipAddress,
  dealershipCity,
  dealershipState,
  dealershipZipCode,
  funderName,
  funderAddress,
  funderCity,
  funderState,
  funderZipCode,
  funderPhoneNumber,
  funderEmail,
}) {
  return client(
    `${process.env.NEXT_PUBLIC_ACCOUNT_DOMAIN}/${process.env.NEXT_PUBLIC_IDENTITY_VERSION}/user/ChangeDealerDetails`,
    {
      headers: { 'Content-Type': 'application/json' },
      method: 'POST',
      body: JSON.stringify({
        userId,
        firstName,
        lastName,
        phoneNumber,
        zipCode,
        dealerUserType,
        dealershipName,
        dealershipAddress,
        dealershipCity,
        dealershipState,
        dealershipZipCode,
        funderName,
        funderAddress,
        funderCity,
        funderState,
        funderZipCode,
        funderPhoneNumber,
        funderEmail,
      }),
    },
  )
}
